import { render, staticRenderFns } from "./PointSystemManage.vue?vue&type=template&id=4c651d22&"
import script from "./PointSystemManage.vue?vue&type=script&lang=js&"
export * from "./PointSystemManage.vue?vue&type=script&lang=js&"
import style0 from "./PointSystemManage.vue?vue&type=style&index=0&id=4c651d22&lang=scss&"
import style1 from "./PointSystemManage.vue?vue&type=style&index=1&id=4c651d22&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c651d22')) {
      api.createRecord('4c651d22', component.options)
    } else {
      api.reload('4c651d22', component.options)
    }
    module.hot.accept("./PointSystemManage.vue?vue&type=template&id=4c651d22&", function () {
      api.rerender('4c651d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/points/point-system-manage/PointSystemManage.vue"
export default component.exports